export default __webpack_public_path__ + "static/media/IMG_3554.10c8c06e.jpeg";